import boy from  "../../../assets/image copy 4.png"
import Ecosystem from "./Ecosystem"
import Slider from "./Slider"
import WhyChooseUs from "./WhyChooseUs";

export default function Contant() {
  
 const FEATURES = [
  {
    image: "https://zaptodoor.com/upload/file_6971d9376e0108.33087191.jfif",
    bg: "linear-gradient(135deg,#faf5ff,#ede9fe)",
    accent: "#7c3aed",
    title: "2 KM Free Delivery",
    desc: "Zero delivery charge on all orders within 2 km of your location.",
  },

  {
    image: "https://zaptodoor.com/upload/file_6971d9a97d17e9.71719349.jfif",
    bg: "linear-gradient(135deg,#fdf2f8,#fce7f3)",
    accent: "#db2777",
    title: "Monthly Rewards",
    desc: "Earn points on every order and redeem for exciting gifts each month.",
  },

  {
    image: "https://zaptodoor.com/upload/file_6971d97f539a27.95832544.jfif",
    bg: "linear-gradient(135deg,#eff6ff,#dbeafe)",
    accent: "#2563eb",
    title: "Smart Cart",
    desc: "Intelligent cart that remembers your preferences and reorders in one tap.",
  },

  {
    image: "https://zaptodoor.com/upload/file_6972434e01c837.49431007.jfif",
    bg: "linear-gradient(135deg,#f0fdf4,#dcfce7)",
    accent: "#16a34a",
    title: "Best Prices",
    desc: "Price-matched across all restaurant partners. Always the best deal.",
  },

  {
    image: "https://zaptodoor.com/upload/file_697243c5b85a68.36847179.jfif",
    bg: "linear-gradient(135deg,#faf5ff,#ede9fe)",
    accent: "#7c3aed",
    title: "Up to 50% Off",
    desc: "Exclusive member-only discounts on your favourite items every day.",
  },
];

  return (
    <main style={{ width: '100%', overflowX: 'hidden' }}>
      {/* HERO */}
    {/* HERO */}
<section
  style={{
    position: "relative",
    minHeight: "90vh",
    display: "flex",
    alignItems: "center",
    padding: "0px 20px 60px", // pehle 120px tha
    marginTop: "0",
    background:
      "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
    overflow: "hidden",
  }}
>
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background:
        "radial-gradient(circle at 70% 30%, rgba(124,58,237,0.1) 0%, transparent 50%)",
      pointerEvents: "none",
    }}
  />

  <div
    style={{
      maxWidth: "1200px",
      margin: "0 auto",
      width: "100%",
      display: "grid",
      gridTemplateColumns:
        "repeat(auto-fit,minmax(300px,1fr))",
      gap: "60px",
      alignItems: "center",
      position: "relative",
      zIndex: 1,
    }}
  >
    {/* LEFT */}
    <div>
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          background: "white",
          padding: "8px 20px",
          borderRadius: "50px",
          fontSize: "14px",
          fontWeight: 500,
          marginBottom: "20px",
          boxShadow:
            "0 2px 8px rgba(0,0,0,0.08)",
        }}
      >
        <span
          style={{
            width: "8px",
            height: "8px",
            background: "#22c55e",
            borderRadius: "50%",
            display: "inline-block",
            animation: "pulse 2s infinite",
          }}
        />
        Delivering across Gwalior & beyond
      </div>

      <h1
        style={{
          fontSize: "clamp(36px,5vw,64px)",
          fontWeight: "800",
          lineHeight: "1.1",
          margin: "0 0 20px",
          color: "#0f172a",
        }}
      >
        Food you love,
        <br />
        <span style={{ color: "#7c3aed" }}>
          delivered fast.
        </span>
      </h1>

      <p
        style={{
          fontSize: "18px",
          color: "#64748b",
          lineHeight: "1.6",
          marginBottom: "25px",
          maxWidth: "500px",
        }}
      >
        Fresh flavours from 361+ restaurant
        partners, straight to your door.
        Free delivery within 2 km.
      </p>

      <a
        href="https://play.google.com/store/apps/details?id=com.zaptodoor.user"
        target="_blank"
        rel="noreferrer"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "10px",
          background: "#7c3aed",
          color: "#fff",
          padding: "16px 30px",
          borderRadius: "12px",
          textDecoration: "none",
          fontWeight: "600",
          boxShadow:
            "0 4px 12px rgba(124,58,237,.3)",
        }}
      >
        <i className="bi bi-google-play" />
        Order Now
      </a>
    </div>

    {/* RIGHT IMAGE */}
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <img
        src={boy}
        alt=""
        style={{
          width: "100%",
          maxWidth: "500px",
          borderRadius: "25px",
        }}
      />
    </div>
  </div>
</section>

      {/* STATS */}
   <div
  style={{
    background:
      "linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)",
    padding: "30px 20px",
  }}
>
  <div
    style={{
      maxWidth: "1200px",
      margin: "0 auto",
      display: "grid",
      gridTemplateColumns:
        "repeat(auto-fit, minmax(180px, 1fr))",
      gap: "25px",
    }}
  >
    {[
      {
        v: "1,600+",
        l: "Happy Customers",
        i: "bi-emoji-smile-fill",
        c: "#7c3aed",
      },
      {
        v: "361",
        l: "Restaurant Partners",
        i: "bi-shop",
        c: "#2563eb",
      },
      {
        v: "2 km",
        l: "Free Delivery Radius",
        i: "bi-bicycle",
        c: "#16a34a",
      },
      {
        v: "50%",
        l: "Max Discount",
        i: "bi-tags-fill",
        c: "#ea580c",
      },
      {
        v: "3.7 ★",
        l: "App Rating",
        i: "bi-star-fill",
        c: "#f59e0b",
      },
    ].map(({ v, l, i, c }) => (
      <div
        key={l}
        style={{
          background: "rgba(255,255,255,0.8)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(255,255,255,0.4)",
          borderRadius: "22px",
          padding: "35px 20px",
          textAlign: "center",
          boxShadow:
            "0 10px 30px rgba(0,0,0,0.06)",
          transition: "all 0.35s ease",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform =
            "translateY(-8px) scale(1.03)";
          e.currentTarget.style.boxShadow =
            "0 20px 40px rgba(124,58,237,0.18)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform =
            "translateY(0) scale(1)";
          e.currentTarget.style.boxShadow =
            "0 10px 30px rgba(0,0,0,0.06)";
        }}
      >
        {/* ICON */}
        <div
          style={{
            width: "70px",
            height: "70px",
            margin: "0 auto 18px",
            borderRadius: "50%",
            background: `${c}15`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <i
            className={`bi ${i}`}
            style={{
              fontSize: "32px",
              color: c,
            }}
          />
        </div>

        {/* VALUE */}
        <strong
          style={{
            fontSize: "34px",
            fontWeight: "800",
            color: "#0f172a",
            display: "block",
            marginBottom: "8px",
          }}
        >
          {v}
        </strong>

        {/* LABEL */}
        <span
          style={{
            fontSize: "15px",
            color: "#64748b",
            fontWeight: "500",
            letterSpacing: "0.3px",
          }}
        >
          {l}
        </span>
      </div>
    ))}
  </div>
</div>
 <WhyChooseUs/>

<Slider />

      {/* DOWNLOAD BANNER */}
      <section style={{
        padding: '80px 20px',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 30% 50%, rgba(124,58,237,0.2) 0%, transparent 50%)',
          pointerEvents: 'none'
        }} />
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '60px',
          alignItems: 'center',
          position: 'relative',
          zIndex: 1
        }}>
          <div>
            <span style={{
              color: '#a78bfa',
              fontWeight: 600,
              fontSize: '14px',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              marginBottom: '16px',
              display: 'block'
            }}>Available on Android</span>
            <h2 style={{
              fontSize: 'clamp(28px, 4vw, 48px)',
              fontWeight: 800,
              lineHeight: 1.2,
              margin: '0 0 16px',
              color: 'white'
            }}>
              Smarter deliveries<br />for everyday living.
            </h2>
            <p style={{ 
              fontSize: '18px', 
              color: '#94a3b8', 
              marginBottom: '32px',
              maxWidth: '500px',
              lineHeight: 1.6
            }}>
              One app. Thousands of flavours. Real-time tracking. Zero hassle.
            </p>
            <a href="https://play.google.com/store/apps/details?id=com.zaptodoor.user" target="_blank" rel="noreferrer">
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" 
                alt="Get it on Google Play" 
                style={{ height: '50px' }}
              />
            </a>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <img 
              src="https://zaptodoor.com/upload/file_69806ec2dfdb52.18567712.png" 
              alt="" 
              style={{ maxWidth: '100%', height: 'auto', maxHeight: '400px' }}
            />
          </div>
        </div>
      </section>

      {/* ECOSYSTEM */}

      <Ecosystem/>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @media (max-width: 768px) {
          section {
            padding: 60px 16px !important;
          }
        }
      `}</style>
    </main>
  );
}